export interface TableConfig {
  tableType: TableType;
  dataSource: string;
  heading: string;
  displayedColumns: string[];
  columnWidths: string | { [key: string]: string };
  cssClass: string;
}

export enum TableType {
  ACTIVE = 'activeReports',
  SOLVED = 'solvedReports',
  ESCALATED = 'escalatedReports'
}

export const PAGE_SIZE: number = 5;

export const TABLE_CONFIG: { [key: string]: TableConfig } = {
  activeReports: {
    tableType: TableType.ACTIVE,
    dataSource: 'activeReports',
    heading: 'Aktive Stillstandsmeldungen',
    displayedColumns: ['id', 'time', 'reason'],
    columnWidths: {"id": "40%", "time": "20%", "reason": "40%"},
    cssClass: 'active-report-container'
  },
  reports: {
    tableType: TableType.SOLVED,
    dataSource: 'reports',
    heading: 'Stillstandsmeldungen',
    displayedColumns: ['id', 'time', 'reason'],
    columnWidths: {"id": "40%", "time": "20%", "reason": "40%"},
    cssClass: 'report-container'
  },
  escalatedReports: {
    tableType: TableType.ESCALATED,
    dataSource: 'escalatedReports',
    heading: 'Eskalationen',
    displayedColumns: ['id', 'time', 'reason'],
    columnWidths: {"id": "40%", "time": "20%", "reason": "40%"},
    cssClass: 'escalation-container'
  }
};
